var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu hide"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5825 6C11.5825 5.44772 12.0302 5 12.5825 5H20.5825C21.1348 5 21.5825 5.44772 21.5825 6C21.5825 6.55228 21.1348 7 20.5825 7H12.5825C12.0302 7 11.5825 6.55228 11.5825 6Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5825 11.0024H5.4125L8.2925 8.12242C8.6825 7.73242 8.6825 7.10242 8.2925 6.71242C7.9025 6.32242 7.2725 6.32242 6.8825 6.71242L2.2925 11.3024C1.9025 11.6924 1.9025 12.3224 2.2925 12.7124L6.8825 17.3024C7.2725 17.6924 7.9025 17.6924 8.2925 17.3024C8.6825 16.9124 8.6825 16.2824 8.2925 15.8924L5.4125 13.0024H20.5825C21.1325 13.0024 21.5825 12.5524 21.5825 12.0024C21.5825 11.4524 21.1325 11.0024 20.5825 11.0024Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5825 17C12.0302 17 11.5825 17.4477 11.5825 18C11.5825 18.5523 12.0302 19 12.5825 19H20.5825C21.1348 19 21.5825 18.5523 21.5825 18C21.5825 17.4477 21.1348 17 20.5825 17H12.5825Z",
    fill: "#121212"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.b8fc90ae3f8639bea57786343cff2f72.svg";
export { ForwardRef as ReactComponent };